import { authServiceApi } from "../../app/authServiceApi";
import { API_URL } from "../../constants/apiUrl";
import { AUTH_LOCALSTORAGE_NAME } from "../../constants/constants";
import {
  ForgotPasswordDataType,
  GetLocationResponseType,
  PatchQueryArgsType,
  SigninDataType,
  SigninResponsiveType,
  SignupDataType,
  SignupResponseType,
} from "../../types";
import { setToken, userLoggedIn } from "./authSlice";

const KC_URL =
  process.env.REACT_APP_KEYCLOAK_URL || "https://sso.dev-sheba.xyz";
const REALM = process.env.REACT_APP_KEYCLOAK_REALM || "master";
const CLIENT_ID = process.env.REACT_APP_KEYCLOAK_CLIENT_ID || "digigo";

export const authApi = authServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    signin: builder.mutation<SigninResponsiveType, SigninDataType>({
      query: (data) => ({
        url: API_URL.signin,
        method: "POST",
        body: data,
      }),
      async onQueryStarted(_, { queryFulfilled, dispatch }) {
        try {
          const { data } = await queryFulfilled;

          // if (data?.data?.userData?.type !== "Admin") {
          //   return toast(
          //     "error",
          //     "You are not allowed to log in. Please try logging in using your mobile app"
          //   );
          // }

          const userData = {
            access_token: data?.data?.token,
            user: data,
            role: data?.data?.userData?.type,
          };

          localStorage.setItem(
            AUTH_LOCALSTORAGE_NAME,
            JSON.stringify(userData)
          );

          dispatch(userLoggedIn(userData));
        } catch (err) {}
      },
    }),
    signup: builder.mutation<SignupResponseType, SignupDataType>({
      query: (data) => ({
        url: API_URL.signup,
        method: "POST",
        body: data,
      }),
    }),
    forgotPassword: builder.mutation<unknown, ForgotPasswordDataType>({
      query: (data) => ({
        url: API_URL.forgotPassword,
        method: "PATCH",
        body: data,
      }),
    }),
    changePassword: builder.mutation({
      query: (data) => ({
        url: API_URL.changePassword,
        method: "PATCH",
        body: data,
      }),
    }),
    resetPassword: builder.mutation({
      query: (data) => ({
        url: API_URL.resetPassword,
        method: "PATCH",
        body: data,
      }),
    }),
    getLocation: builder.query<GetLocationResponseType, unknown>({
      query: () => API_URL.getLocation,
    }),
    updateCompleteProfile: builder.mutation<unknown, PatchQueryArgsType>({
      query: ({ body, id }) => ({
        url: `${API_URL.updateCompleteProfile}/${id}`,
        method: "PATCH",
        body,
      }),
    }),
    profileUpdate: builder.mutation({
      query: (data) => ({
        url: API_URL.profileUpdate,
        method: "POST",
        body: data,
      }),
    }),
    companyProfileUpdate: builder.mutation({
      query: (data) => ({
        url: API_URL.companyProfileUpdate,
        method: "POST",
        body: data,
      }),
    }),
    sendVerificationEmail: builder.mutation({
      query: (data) => ({
        url: API_URL.sendVerificationEmail,
        method: "POST",
        body: data,
      }),
    }),
    verifyEmail: builder.mutation({
      query: (data) => ({
        url: API_URL.verifyEmail,
        method: "POST",
        body: data,
      }),
    }),
    keycloakLogin: builder.mutation({
      query: ({ username, password }) => ({
        url: `${KC_URL}/realms/${REALM}/protocol/openid-connect/token`,
        method: "POST",
        body: new URLSearchParams({
          client_id: CLIENT_ID,
          grant_type: "password",
          username,
          password,
        }),
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      }),
      async onQueryStarted(_, { queryFulfilled, dispatch }) {
        try {
          const { data } = await queryFulfilled;

          localStorage.setItem(
            AUTH_LOCALSTORAGE_NAME,
            JSON.stringify({ access_token: data.access_token, kc: data })
          );

          dispatch(setToken(data));
        } catch (err) {
          /* silent */

          console.log("Keycloak login error:", err);
        }
      },
    }),
  }),
});

export const {
  useSigninMutation,
  useSignupMutation,
  useForgotPasswordMutation,
  useChangePasswordMutation,
  useGetLocationQuery,
  useUpdateCompleteProfileMutation,
  useProfileUpdateMutation,
  useCompanyProfileUpdateMutation,
  useResetPasswordMutation,
  useSendVerificationEmailMutation,
  useVerifyEmailMutation,
  useKeycloakLoginMutation,
} = authApi;
